export const isErrorDisplayingSelector = state => state.displayErrorNotification;
